import { useAccountFlipperFeatureFlags } from '@libs/data-access/queries'
import useMemoSelector from '@spa/redux/hooks/useMemoSelector'
import { noteModalDef } from '@spa/scenes/Plannings/Modals/NoteModal'
import type { FC } from 'react'
import React from 'react'

import { noteModalLegacyDef } from '../../../Modals'
import {
  getIsoDaysInTimeRange,
  usePlanningPolicies,
  weeklyschedulesSelectors
} from '../../../redux/selectors'
import Calendar from '../../Calendar/Calendar'

import DayNote from './Cell/DayNote'
import DragNote from './Cell/DragNote/DragNote'
import { NoteDropZone } from './Cell/NoteDropZone'

type Props = {
  weeklyscheduleId: number
}

const TeamNotesComponent: FC<Props> = ({ weeklyscheduleId }) => {
  const accountFF = useAccountFlipperFeatureFlags()
  const { open: openNoteLegacy } = noteModalLegacyDef.useDispatchModal()
  const { open } = noteModalDef.useDispatchModal()
  const weeklyschedule =
    weeklyschedulesSelectors.useGetCachedById(weeklyscheduleId)

  const isoDays = useMemoSelector(getIsoDaysInTimeRange)
  const notes = useMemoSelector(state =>
    weeklyschedulesSelectors.getWeekNotes(state, weeklyscheduleId)
  )

  const { canEditNotes } = usePlanningPolicies()

  if (notes === null) {
    return null
  }

  return (
    <Calendar.Row>
      <Calendar.Cell aside />
      <Calendar.Cell noPadding noBorder>
        <Calendar.Row noBorder>
          {isoDays.map(day => {
            return (
              <Calendar.Cell secondary key={`team-day-note-${day}`}>
                <NoteDropZone weeklyscheduleId={weeklyschedule.id} date={day}>
                  {notes[day]?.map(note => {
                    return (
                      <DragNote key={note.id} noteId={note.id}>
                        <DayNote
                          canEditNotes={canEditNotes}
                          note={note.note}
                          onClick={() => {
                            if (accountFF?.scheduling_burning_redux) {
                              open({
                                noteId: note.id,
                                date: note.date,
                                weeklyscheduleId
                              })
                            } else {
                              openNoteLegacy({
                                noteId: note.id,
                                date: note.date,
                                weeklyscheduleId
                              })
                            }
                          }}
                        />
                      </DragNote>
                    )
                  })}
                </NoteDropZone>
              </Calendar.Cell>
            )
          })}
        </Calendar.Row>
      </Calendar.Cell>
    </Calendar.Row>
  )
}

TeamNotesComponent.displayName = 'TeamNotes'

export const TeamNotes = React.memo(TeamNotesComponent)
